/**
 * Created by Roman T on 1/29/2018.
 */
var bfBind = { data: '=' };
var DetailEligibilityDecisionAutoController = (function () {
    function DetailEligibilityDecisionAutoController($scope, socket, settings, topic, Dialog, $state, $timeout, env, $http, notify) {
        var _this = this;
        this.$scope = $scope;
        this.socket = socket;
        this.settings = settings;
        this.topic = topic;
        this.Dialog = Dialog;
        this.$state = $state;
        this.$timeout = $timeout;
        this.env = env;
        this.$http = $http;
        this.notify = notify;
        this.desArray = ['IBM-Led', 'BP-Led', 'Co-Led', 'Not determined', 'Unassigned'];
        this.sectionHeader = 'Customer Designation';
        this.comp = 'customerDesignation';
        this.isResetting = false;
        this.cdResult = angular.isDefined(this.data) ? this.data : undefined;
        this.cmrArray = (angular.isDefined(this.data) && angular.isDefined(this.data.CMR))
            ? this.data.CMR.cmrCheckResults
            : undefined;
        this.finalTimestamp = this.cmrArray ? this.data.CMR.finalTimestamp : undefined;
        this.customerDesignation = (angular.isDefined(this.data) && !this.data.isError)
            ? this.data.data // CD check data
            : 'Not determined';
        this.isCDcheckPerformed = angular.isDefined(this.customerDesignation) && this.customerDesignation !== 'Not determined' && this.customerDesignation !== 'Unknown';
        this.OPP_VERSION_5 = 5;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (!_this.isCDcheckPerformed) {
                _this.customerDesignation = _this.topic.topic.customerDesignation;
                _this.isResetting = false;
            }
        });
    }
    DetailEligibilityDecisionAutoController.prototype.showCmrDataList = function (event) {
        var items = {
            dialogName: this.cmrArray,
            columnHeaders: [
                'Account Name',
                'Customer Designation',
                'Country',
                'CMR Number',
                'DCID'
            ]
        };
        this.Dialog.updateValidForm(event, items, 'cmrCdData-dialog.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
    };
    DetailEligibilityDecisionAutoController.prototype.excelExport = function () {
        console.log('sending export Excel request');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'exportReportExcel',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token,
                data: {
                    id: this.topic.getId(this.topic.topic._id),
                    comp: 'cd',
                    cmrArray: this.cmrArray,
                    timestamp: this.finalTimestamp
                }
            }
        });
    };
    DetailEligibilityDecisionAutoController.prototype.showOverrideButton = function () {
        if (this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_5) {
            return false;
        }
        else {
            return !this.isCDcheckPerformed;
        }
    };
    DetailEligibilityDecisionAutoController.prototype.resetDecision = function (event) {
        var _this = this;
        // Prepare data to be saved
        var cdFlagArray = ['IBM-Led', 'BP-Led', 'Co-Led', 'Unassigned'];
        var currentFlag = this.topic.topic.customerDesignation ? this.topic.topic.customerDesignation : 'Not determined';
        var flagItems = {
            cdFlags: cdFlagArray,
            cdFlag: currentFlag,
            original: currentFlag,
            message: 'Please confirm the designation should be overridden:',
            okMessage: 'OK',
            cancelMessage: 'Cancel',
            dialogName: 'Designation Override',
            addCancel: false
        };
        this.Dialog.updateValidForm(event, flagItems, 'detail-elig-designation-dialog.html').then(function (dResult) {
            if (dResult.confirm && dResult.comment && dResult.comment.trim() !== '' && dResult.cdFlag.trim() !== '') {
                if (_this.topic.updatePartialSocketStatus([_this.comp], 'Updating')) {
                    // Prepare data to be saved
                    var updateObject = {
                        data: (_a = {},
                            _a['comments.eligibility'] = {
                                push: true,
                                data: [{
                                        comment: 'Designation changed from: ' + _this.topic.temp.customerDesignation + ' to ' + dResult.cdFlag + '; ' + dResult.comment,
                                        user: _this.env.user.email
                                    }]
                            },
                            _a.customerDesignation = {
                                add: true,
                                data: dResult.cdFlag
                            },
                            _a
                        ),
                        id: _this.topic.topic._id,
                        type: ['comments', 'customerDesignation']
                    };
                    var check = [{
                            name: 'CD',
                            value: dResult.cdFlag,
                            id: _this.topic.topic._id.substr(4)
                        }];
                    _this.topic.updateServerTopic('couchUpdate', updateObject, true, check); // Send it to be saved
                    _this.isResetting = true;
                }
            }
            var _a;
        });
    };
    DetailEligibilityDecisionAutoController.prototype.isEligibilityCompleted = function () {
        return !(this.topic.topic.status.status_no === 3
            && [3, 4, 23, 28, 29, 32, 33].indexOf(this.topic.topic.status.sub_status_no) < 0);
    };
    DetailEligibilityDecisionAutoController.prototype.$onInit = function () {
        if (this.topic.topic.customerDesignation && ['Not determined', 'Unknown'].indexOf(this.topic.topic.customerDesignation) < 0) {
            this.customerDesignation = this.topic.topic.customerDesignation;
        }
    };
    DetailEligibilityDecisionAutoController.$inject = ['$scope', 'socket', 'settings', 'topic', 'Dialog', '$state', '$timeout', 'env', '$http', 'notify', 'Dialog'];
    return DetailEligibilityDecisionAutoController;
}());
var DetailEligibilityDecisionAutoComponent = (function () {
    function DetailEligibilityDecisionAutoComponent() {
        this.templateUrl = 'detail-eligibility-designation-auto.html';
        this.bindings = bfBind;
        this.controller = DetailEligibilityDecisionAutoController;
        this.controllerAs = 'vm';
    }
    return DetailEligibilityDecisionAutoComponent;
}());
angular
    .module('application')
    .component('customerDesignationAuto', new DetailEligibilityDecisionAutoComponent());

//# sourceMappingURL=detail.eligibility.designation.auto.component.js.map
